var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"small-padding mb-2  "},[_c('b-table',{staticClass:"mt-2 match-score-table",attrs:{"items":_vm.items,"fields":_vm.fields,"small":""},on:{"row-clicked":_vm.rowClicked,"head-clicked":_vm.headClicked}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }